<div class="flex-alert-column alert alert-{{ priority !== undefined && priority !== null ? priority : 0 }}">
  <div class="flex-container" [innerHTML]="'<p></p>' + displayValue"></div>
  @if(attachmentList && attachmentList.length > 0) {
  <div class="flex-alert-column border-alert-top">
    @for (attachment of attachmentList; track attachment.id) {
    <a class="ml-2 mark-on-hover" (click)="onAttachmentClick(attachment)"
      ><b class="dx-icon-pdffile"></b><u>{{ attachment.fileName }}</u></a
    >
    }
  </div>
  }
  <div class="flex-alert-row border-alert-top mt-2" *ngIf="footerText || showTrashCan">
    <div *ngIf="footerText" class="flex-container align-self-start">
      {{ footerText }}
    </div>
    <div *ngIf="showTrashCan" class="ml-2 flex-container">
      <a class="mark-on-hover" (click)="onDeleteClick()"><i class="dx-icon dx-icon-trash"></i></a>
    </div>
  </div>
</div>
